import { render } from "./Block.vue?vue&type=template&id=f02463b0"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"
script.render = render

export default script